import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { UserFriendIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/recommendation-management/main-page/$store-list/$host-list')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="recommendationManagement.hostList.crumb" icon={UserFriendIcon} />,
      title: <Translation id="recommendationManagement.hostList.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
